// client/src/components/admin/AdminInterestedUsers.js
import { useEffect, useState } from 'react'
import ApiInterestedUsers from '../../api/ApiInterestedUsers'
import PageLayout from '../common/layout/PageLayout'

function AdminInterestedUsers() {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function load() {
      try {
        const data = await ApiInterestedUsers.getAll()
        setUsers(data?.data || [])
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  if (loading) {
    return (
      <PageLayout title="Interested Users" noCard={true}>
        <p>Loading...</p>
      </PageLayout>
    )
  }

  if (error) {
    return (
      <PageLayout title="Interested Users" noCard={true}>
        <p className="text-danger">{error}</p>
      </PageLayout>
    )
  }

  return (
    <PageLayout title="Interested Users" noCard={true}>
      <div className="mb-3">
        <p className="text-muted">
          Users who expressed interest in joining without an access code.
        </p>
      </div>

      {users.length === 0 ? (
        <div className="alert alert-info">
          No interested users yet. They will appear here when users submit their
          email on the signup page.
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Submitted</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>
                    <a href={`mailto:${user.email}`}>{user.email}</a>
                  </td>
                  <td>
                    {user.submitted_at
                      ? new Date(user.submitted_at).toLocaleString()
                      : user.created_at
                        ? new Date(user.created_at).toLocaleString()
                        : 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="mt-4">
        <p className="text-muted small">
          <strong>Total interested users:</strong> {users.length}
        </p>
      </div>
    </PageLayout>
  )
}

export default AdminInterestedUsers
